import React from "react";
import UserHOC from "../../../components/shared/HOC/UserHOC";
import { useGroupHistoryUser } from "../../../hooks/UserHooks/MyGroupsHooks/useUserGroupData";
import CommonTable from "../../../components/shared/table/Table";
import { useParams } from "react-router-dom";
import { courseColumns, userColumns } from "../../../assets/constants/user/group-history";
import { useGroupHistoryCourse } from "../../../hooks/UserHooks/MyGroupsHooks/useCourseGroupData";


 
const GroupUserHistory = () => {
  const { id } = useParams();

  const {
    groupUserData,
    Userloading,
    paginationConfig,
    handlePageChange,
    getGroupData,
  } = useGroupHistoryUser(id);


  const {     groupCourseData,
    courseLoading,
    paginationConfig: coursePaginationConfig,
    handlePageChange: handleCoursePageChange,
    getGroupData: getCourseGroupData, } = useGroupHistoryCourse(id);

  return (
    <div className="rounded-[10px] border p-4 border-[#e8e8e8] bg-white shadow-[0_0_6px_#0000000D] overflow-visible">
      <div className="flex justify-between mb-4">
        <p className="font-medium text-[28px] text-[#E74860]">Group History</p>
      </div>

      <div className="flex gap-4">
        <CommonTable
          data={groupUserData}
          columns={userColumns}
          showLoader={Userloading}
          pagination={paginationConfig}
          onChange={handlePageChange}
        />
        <CommonTable
          data={groupCourseData}
          columns={courseColumns}
          showLoader={courseLoading}
          pagination={coursePaginationConfig}
          onChange={handleCoursePageChange}
        />
      </div>
    </div>
  );
};

export default UserHOC(GroupUserHistory);
